import React, { useEffect, useState } from 'react';
import { getSlimLogoPath, SLIM_LOGO_DEV, SLIM_LOGO_PROD } from '../../utils/slimLogo';

const PublicSlimHeader = ({
  title,
  subtitle,
  logoAlt = 'SLIM ERP Logo',
  logoSrc,
  logoClassName = 'h-14 w-auto',
  rightLogoSrc = '',
  rightLogoAlt = 'Event Logo',
  rightLogoClassName = 'h-14 w-14 rounded-full object-contain',
  className = '',
}) => {
  const resolvedLogo = logoSrc || getSlimLogoPath();
  const [imgSrc, setImgSrc] = useState(resolvedLogo);
  const [rightImgSrc, setRightImgSrc] = useState(rightLogoSrc || '');

  useEffect(() => {
    setImgSrc(logoSrc || getSlimLogoPath());
  }, [logoSrc]);
  useEffect(() => {
    setRightImgSrc(rightLogoSrc || '');
  }, [rightLogoSrc]);

  return (
    <div className={`bg-white rounded-lg shadow-md print:shadow-none px-5 py-3 mb-4 print:mb-2 ${className}`.trim()}>
      <div className="relative flex items-center justify-center min-h-[48px]">
        <img
          src={imgSrc}
          alt={logoAlt}
          className={`absolute left-0 top-1/2 -translate-y-1/2 ${logoClassName}`}
          onError={() => {
            const alt = imgSrc === SLIM_LOGO_PROD ? SLIM_LOGO_DEV : SLIM_LOGO_PROD;
            if (imgSrc !== alt) setImgSrc(alt);
          }}
        />
        <div className="text-center px-4">
          <h1 className="text-xl font-bold text-gray-900 leading-tight">{title}</h1>
          {subtitle ? <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p> : null}
        </div>
        {rightImgSrc ? (
          <img
            src={rightImgSrc}
            alt={rightLogoAlt}
            className={`absolute right-0 top-1/2 -translate-y-1/2 ${rightLogoClassName}`}
            onError={() => setRightImgSrc('')}
          />
        ) : null}
      </div>
    </div>
  );
};

export default PublicSlimHeader;
